import {Component} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromRoot from '../reducers';

@Component({
  selector: 'app-admin-cards',
  template: `<div class="row">
                <div class="col-md-12">
                  <admin-buttons [isSuperUser]="isSuperUser$ | async"></admin-buttons>
                </div>
              </div>`
})
export class AdminDashboardPageComponent {
  isSuperUser$: Observable<boolean>;
  constructor(private store: Store<fromRoot.State>) {
    this.isSuperUser$ = this.store.select(fromRoot.getAuthIsSuperAdmin);
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/containers/admin-dashboard.ts